<template>
  <div>
    <div class="row" v-if="!isHomeDashboard">
      <div class="col-12">
        <DashboardContentBox>
          <div class="heading-box">
            <img src="glass/img/dashboard-header-image.png" class="heading-image" />
            <div class="dashboard-header">
              <h2>{{profileCompanyName}}</h2>
              <div class="pt-4 pb-1">
                <TabPillButton tabid="tab-overview" v-model="currentTab">Overview</TabPillButton>
                <TabPillButton tabid="tab-contact" v-model="currentTab" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceSalesPricing)">Contacts</TabPillButton>
                <TabPillButton tabid="tab-inventory" v-model="currentTab" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceInventory)">Inventory</TabPillButton>
                <TabPillButton tabid="tab-purchasing" v-model="currentTab" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceInventory)">Purchasing</TabPillButton>
                <TabPillButton tabid="tab-orders" v-model="currentTab" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceOrder)">Orders</TabPillButton>
                <TabPillButton tabid="tab-quotes" v-model="currentTab" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceOrder)">Quotes</TabPillButton>
                <TabPillButton tabid="tab-ncr" v-model="currentTab" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceOrder)">NCRs</TabPillButton>
                <TabPillButton tabid="tab-production" v-model="currentTab" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceProduction)">Production</TabPillButton>
                <TabPillButton tabid="tab-optimiser" v-model="currentTab" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceProduction)">Optimiser</TabPillButton>
                <TabPillButton tabid="tab-recuts" v-model="currentTab" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceProduction)">Recuts</TabPillButton>
                <TabPillButton tabid="tab-task" v-model="currentTab" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceProduction)">Tasks</TabPillButton>
                <TabPillButton tabid="tab-accounts" v-model="currentTab" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceAccount)">Accounts</TabPillButton>
                <TabPillButton tabid="tab-system" v-model="currentTab" v-if="false">System</TabPillButton>
              </div>
            </div>            
          </div>
        </DashboardContentBox>
      </div>
    </div>

    <TabPillContent tabid="tab-overview" :currentTab="currentTab" v-if="!isHomeDashboard">
      <AnalyticsOverviewDashboard />
    </TabPillContent>

    <TabPillContent tabid="tab-contact" :currentTab="currentTab" v-if="!isHomeDashboard">
      <AnalyticsContactDashboard />
    </TabPillContent>

    <TabPillContent tabid="tab-inventory" :currentTab="currentTab" v-if="!isHomeDashboard">
      <AnalyticsInventoryDashboard />
    </TabPillContent>

    <TabPillContent tabid="tab-purchasing" :currentTab="currentTab" v-if="!isHomeDashboard">
      <AnalyticsPurchasingDashboard />
    </TabPillContent>

    <TabPillContent tabid="tab-orders" :currentTab="currentTab" v-if="!isHomeDashboard">
      <AnalyticsOrderDashboard />
    </TabPillContent>

    <TabPillContent tabid="tab-quotes" :currentTab="currentTab" v-if="!isHomeDashboard">
      <AnalyticsQuotesDashboard />
    </TabPillContent>

    <TabPillContent tabid="tab-ncr" :currentTab="currentTab" v-if="!isHomeDashboard">
      <AnalyticsNCRDashboard />
    </TabPillContent>

    <TabPillContent tabid="tab-production" :currentTab="currentTab" v-if="!isHomeDashboard">
      <AnalyticsProductionDashboard />
    </TabPillContent>

    <TabPillContent tabid="tab-optimiser" :currentTab="currentTab" v-if="!isHomeDashboard">
      <AnalyticsOptimiserDashboard />
    </TabPillContent>

    <TabPillContent tabid="tab-recuts" :currentTab="currentTab" v-if="!isHomeDashboard">
      <AnalyticsRecutDashboard />
    </TabPillContent>

    <TabPillContent tabid="tab-task" :currentTab="currentTab" v-if="!isHomeDashboard">
      <AnalyticsTasksDashboard />
    </TabPillContent>

    <TabPillContent tabid="tab-accounts" :currentTab="currentTab" v-if="!isHomeDashboard">
      <AnalyticsAccountsDashboard />
    </TabPillContent>

    <TabPillContent tabid="tab-system" :currentTab="currentTab" v-if="!isHomeDashboard">
      TODO: Total contacts, orders, invoices, etc etc in the system<br />
    </TabPillContent>

    <div class="row" v-if="isHomeDashboard">
      <div class="col-12">
        <DashboardContentBox>
          <div class="heading-box">
            <img src="glass/img/dashboard-header-image.png" class="heading-image" />
            <div class="dashboard-header">
              <h2>{{profileCompanyName}}</h2>
            </div>            
          </div>
        </DashboardContentBox>
      </div>
    </div>


    <div class="row" v-if="isHomeDashboard">
      <div class="col-12 col-lg-5">
        <DashboardGreetingBox />
      </div>
      <div class="col-7 d-none d-lg-block">
        <DashboardAnalyticsBox /> 
      </div>
    </div>


  </div>
</template>

<style lang="scss" scoped>
.heading-box {
  position: relative;
  min-height: 60px;
  overflow: hidden;
}
.heading-image {
  position: absolute;
  top: 0px;
  left: 0px;
  border-top-left-radius: 6px;
  width: 80px;
}
.heading-edit-dropdown {
  position: absolute;
  top: 10px;
  right: 10px;
}
.dashboard-header {
  padding: 0.5rem;
}
.dashboard-header > h2 {
  color: $general-highlight-color;
  font-weight: 600;
  margin-left: 80px;
}
.analytics-report-group {
  padding: 0.5em;
}
</style>


<script>
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'
import DashboardTabbedContentBox from '@/components/dashboard/dashboardTabbedContentBox'

import TabPillButton from '@/components/layout/tabPillButton.vue'
import TabPillContent from '@/components/layout/tabPillContent.vue'

import AnalyticsReportLink from '@/modules/intelligence/components/analyticsReportLink'

// Testing Widgets
import DashboardGreetingBox from '@/modules/core/components/dashboardGreetingBox'
import DashboardAnalyticsBox from '@/modules/core/components/dashboardAnalyticsBox'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'

// Module Dashboards
import AnalyticsOverviewDashboard from '@/modules/intelligence/reportViews/analyticsOverviewDashboard'
import AnalyticsContactDashboard from '@/modules/intelligence/reportViews/contacts/analyticsContactDashboard'
import AnalyticsInventoryDashboard from '@/modules/intelligence/reportViews/inventory/analyticsInventoryDashboard'
import AnalyticsPurchasingDashboard from '@/modules/intelligence/reportViews/purchasing/analyticsPurchasingDashboard'
import AnalyticsOrderDashboard from '@/modules/intelligence/reportViews/orders/analyticsOrderDashboard'
import AnalyticsQuotesDashboard from '@/modules/intelligence/reportViews/orders/analyticsQuotesDashboard'
import AnalyticsNCRDashboard from '@/modules/intelligence/reportViews/orders/analyticsNCRDashboard'
import AnalyticsProductionDashboard from '@/modules/intelligence/reportViews/production/analyticsProductionDashboard'
import AnalyticsRecutDashboard from '@/modules/intelligence/reportViews/production/analyticsRecutDashboard'
import AnalyticsOptimiserDashboard from '@/modules/intelligence/reportViews/optimiser/analyticsOptimiserDashboard'
import AnalyticsTasksDashboard from '@/modules/intelligence/reportViews/tasks/analyticsTasksDashboard'
import AnalyticsAccountsDashboard from '@/modules/intelligence/reportViews/accounts/analyticsAccountsDashboard'

export default {
  name: 'AnalyticsDashboard',
  components: {
    DashboardContentBox,
    DashboardTabbedContentBox,
    TabPillButton,
    TabPillContent,
    AnalyticsReportLink,
    DashboardGreetingBox,
    DashboardAnalyticsBox,
    AnalyticsWidget,

    AnalyticsOverviewDashboard,
    AnalyticsContactDashboard,
    AnalyticsInventoryDashboard,
    AnalyticsPurchasingDashboard,
    AnalyticsOrderDashboard,
    AnalyticsQuotesDashboard,
    AnalyticsNCRDashboard,
    AnalyticsProductionDashboard,
    AnalyticsRecutDashboard,
    AnalyticsOptimiserDashboard,
    AnalyticsTasksDashboard,
    AnalyticsAccountsDashboard
  },
  props: {
    type: String
  },
  computed: {
    profileCompanyName() {
      return this.$store.state.profile.profileCompanyName
    },
    profileName() {
      return this.$store.state.profile.profileUser.name
    },
    isHomeDashboard() {
      return this.type == 'home'
    }
  },
  data() {
    return {
      currentTab: 'tab-overview'
    }
  },
  created() {
  },
  mounted() {
    if(this.$route.hash) {
      var hashTabId = (this.$route.hash + '').replace('#', '')
      if(hashTabId)
        this.currentTab = hashTabId
    }
  },
  beforeDestroy() {
  }
}
</script>